import { createContext, useContext } from 'react';

const ClerkAuthContext = createContext({
  isSignedIn: false,
  isLoaded: false,
  user: null,
});

export const useClerkAuth = () => useContext(ClerkAuthContext);
export default ClerkAuthContext;
